module.exports = __webpack_public_path__ + "img/logo4.19e3e2de.png";